export const KEY = "7R3BZ-24AE3-RAO3J-3J4MF-N7OXQ-M7BHS";
// const KEY = "5HTBZ-7TF6G-SCJQ4-IPLCK-XC7MJ-IGBW3";

export function searchCityByLatLng (lat, lng) { //根据经纬度查询城市
    return new Promise((resolve, reject) => {
        let citylocations = new qq.maps.CityService();
        citylocations.setComplete(function(result) {
            resolve(result.detail);
        });
        citylocations.setError(function() {
            reject("出错了，请输入正确的经纬度！！！");
        });
        let Lat = new qq.maps.LatLng(lat, lng);
        citylocations.searchCityByLatLng(Lat);
    });
};

export function searchLocalCity () { //城市定位
    return new Promise((resolve, reject) => {
        let citylocations = new qq.maps.CityService();
        citylocations.setComplete(function(result) {
            resolve(result.detail);
        });
        citylocations.setError(function() {
            reject("定位出错啦！");
        });
        citylocations.searchLocalCity();
    });
};